import script from "./BusinessComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./BusinessComponent.vue?vue&type=script&lang=ts&setup=true"

import "./BusinessComponent.vue?vue&type=style&index=0&id=b49710f4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b49710f4"]])

export default __exports__